module.exports = __webpack_public_path__ + "media/images/official/special_hopper-cbd2f9fa1fedd1afb27b660e2e3527c4.jpg";